import { InputField as OrbitInputField } from '@kiwicom/orbit-components';
import type { Props as InputFieldProps } from '@kiwicom/orbit-components/lib/InputField/types';
import type { TranslationType } from '@kiwicom/account-consts';
import { useFormContext } from 'react-hook-form';

type Props = {
  readonly name: string;
  readonly placeholder?: string;
  readonly label?: TranslationType;
  readonly dataTest?: string;
  readonly required?: boolean;
  readonly type?: InputFieldProps['type'];
  readonly disabled?: boolean;
  readonly suffix?: InputFieldProps['suffix'];
  readonly inputMode?: InputFieldProps['inputMode'];
  readonly spaceAfter?: InputFieldProps['spaceAfter'];
};

const InputField = ({ placeholder, name, ...rest }: Props & InputFieldProps): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const { onChange, ...registerRest } = register(name);

  return (
    <OrbitInputField
      {...rest}
      placeholder={placeholder}
      onChange={onChange}
      {...registerRest}
      // @ts-expect-error: react-hook-form returns FieldError which is then resolved to ReactNode based on form schema
      error={errors[name]?.message ?? null}
    />
  );
};

export default InputField;
